import { getLang } from "helpers/themeHelpers";


export const linkToRealEstatePrices = () => {
  const locale = getLang();
  return `/${locale}/${
    locale === "ar" ? "اسعار-العقارات" : "real-estate-prices"
  }`;
};
